import { nextTick, ref, toRaw } from 'vue'
import { searchShopProduct } from '@/apis/associated'
import { useRequest } from '@/util/useLoading'

export const formatProduct = (t: any) => ({
  ...t,
  id: t.shopItemId,
  code: t.thirdItemCode,
  name: t.thirdItemName,
  img: t.thirdItemImage,
  type: 'shopProduct',
  PriceJpy: t.thirdSalePrice ?? 0
})

export const formatProductArr = (data: any) => {
  return (data || []).map((t: any) => formatProduct(t))
}

export default (params: any, getListApi:any) => {
  const list: any = ref([])
  const total = ref()
  const [loading, api] = useRequest(getListApi)
  const pageData = ref({
    pageNum: 1,
    pageSize: 50
  })

  const getList = () => {
    const filter = {
      ...params.value,
      ...toRaw(pageData.value)
    }
    loading.value = true
    api(filter).then((res: any) => {
      list.value = formatProductArr(res.data?.records)
      total.value = res.data.total
    }).finally(() => { loading.value = false })
  }

  return [
    loading,
    pageData,
    list,
    total,
    getList
  ]
}
